import React from 'react';
import { Card, CardHeader, CardActions } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import LightBulbIcon from 'material-ui/svg-icons/action/lightbulb-outline';
import HomeIcon from 'material-ui/svg-icons/action/home';
import CodeIcon from 'material-ui/svg-icons/action/code';
import FlatButton from 'material-ui/FlatButton';

export default ({ style }) => (
    <Card style={style}>
        <CardHeader title="איגוד הסליקה הישראלי " subtitle="איגוד הסליקה הישראלי - דף חשבון" avatar={<Avatar backgroundColor="#FFEB3B" icon={<LightBulbIcon />} />} />
        
    </Card>
);



// WEBPACK FOOTER //
// ./src/dashboard/Welcome.js